import React from "react";

const CheckboxList = (props) => {
  return (
    <>
      {props.items.map((item) => (
        <label key={item.key}>
          <input
            type="checkbox"
            name={item.name}
            checked={item.checked}
            onChange={props.handleChange}
          />
          {item.label}
        </label>
      ))}
    </>
  );
};

export default CheckboxList;
